// Dependency-free on purpose: the sidebar and the Home checklist hook import this, and the
// modal itself pulls in fields, contexts and API hooks that must not ride along (or cycle).

/** Exported so listeners and tests share one literal rather than re-typing it. */
export const REFER_A_BRAND_OPEN_EVENT = 'vera:open-refer-a-brand'

/**
 * Open the globally-mounted "Refer a brand" modal from anywhere — the sidebar row, the
 * Home checklist, the referrals page.
 *
 * Same mechanism as `openToursDialog` / `openKeyboardShortcutsDialog`, for the same reason:
 * three callers in different trees, and a provider would put a React dependency on each of
 * them to carry one boolean. The modal is mounted ONCE in `Layout`.
 */
export const openReferABrandModal = (): void => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(REFER_A_BRAND_OPEN_EVENT))
}
